import { Text } from '@simplywallst/ui-core';

import { formatterCurrency } from '@/utilities/format';

import { CurrencyISO } from '@/constants/currencies';

export const TotalValueMobile = ({
  value,
  currencyISO,
}: {
  value: number;
  currencyISO: CurrencyISO;
}) => {
  if (value === 0) {
    return (
      <Text
        typography="smallStrong"
        textAlign="center"
        color="whiteRGBA"
        opacity={0.3}
      >
        n/a
      </Text>
    );
  }
  return (
    <Text typography="largeStrong" textAlign="center">
      {formatterCurrency(value, currencyISO)}
    </Text>
  );
};
